import { render, staticRenderFns } from "./QuickInvoices.vue?vue&type=template&id=38ba7bd3"
import script from "./QuickInvoices.vue?vue&type=script&lang=js"
export * from "./QuickInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports